import moment from 'moment-timezone'
import api from '@/services/api'

export const state = () => ({
  userIdentity: null,
  userInfo: null,
  adminIdentity: null
})

export const getters = {
  isAuthenticated (state) {
    let isAuthenticated = false
    if (state.userIdentity) {
      const now = moment().tz('Asia/Bangkok')
      const expiredAt = moment(state.userIdentity.expired_at).tz('Asia/Bangkok')
      isAuthenticated = expiredAt.diff(now, 'second') > 0
    }
    return isAuthenticated
  },
  userIdentity (state) {
    return state.userIdentity
  },
  isAdminAuthenticated (state) {
    let isAuthenticated = false
    if (state.adminIdentity) {
      const now = moment().tz('Asia/Bangkok')
      const expiredAt = moment(state.adminIdentity.expired_at).tz('Asia/Bangkok')
      isAuthenticated = expiredAt.diff(now, 'second') > 0
    }
    return isAuthenticated
  },
  adminIdentity (state) {
    return state.adminIdentity
  }
}
export const actions = {
  LOGIN ({ commit }, { email, password }) {
    const context = this.app.context
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .login(email, password).then((userIdentity) => {
          // add timestamp
          const now = moment().tz(context.env.TIMEZONE)
          userIdentity.expired_at = now.add(userIdentity.expires_in, 'seconds')
          commit('LOGIN_SUCCESS', userIdentity)
          resolve(userIdentity)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  ADMIN_LOGIN ({ commit }, { email, password }) {
    const context = this.app.context
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .adminLogin(email, password).then((adminIdentity) => {
          // add timestamp
          const now = moment().tz(context.env.TIMEZONE)
          adminIdentity.expired_at = now.add(adminIdentity.expires_in, 'seconds')
          commit('ADMIN_LOGIN_SUCCESS', adminIdentity)
          resolve(adminIdentity)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  REGISTER ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .register(payload).then((userInfo) => {
          commit('REGISTER_SUCCESS', userInfo)
          resolve(userInfo)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  FORGOT_PASSWORD ({ commit }, email) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .forgotPassword(email).then(() => {
          resolve()
        }).catch((e) => {
          reject(e)
        })
    })
  },
  RESET_PASSWORD ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .resetPassword(payload).then(() => {
          resolve()
        }).catch((e) => {
          reject(e)
        })
    })
  },
  LOGOUT ({ commit, dispatch }) {
    return new Promise((resolve) => {
      commit('LOGOUT_SUCCESS')
      dispatch('user/CLEAR_MY_INFO', null, {
        root: true
      })
      resolve()
    })
  },
  VERIFY_USER (ctx, token) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .verifyUser(token)
        .then((result) => {
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  }
}
export const mutations = {
  LOGIN_SUCCESS (state, userIdentity) {
    state.userIdentity = userIdentity
  },
  ADMIN_LOGIN_SUCCESS (state, adminIdentity) {
    state.adminIdentity = adminIdentity
  },
  LOGOUT_SUCCESS (state) {
    state.userIdentity = null
    state.userInfo = null
    state.adminIdentity = null
  },
  REGISTER_SUCCESS (state, userInfo) {
    state.userInfo = userInfo
  }
}
